import React, { useEffect,useState } from 'react';
import { Routes, Route ,useNavigate,useLocation,Navigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import axios from 'axios';
import './css/styles.css';
import Page404 from './pages/page404/page404';
import { FadeLoader } from 'react-spinners';
//import {BASE_API_URI} from './constant';
//import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from './redux/loaderAction';
import Loader from './components/loader/Loader';
import ProtectedRoute from './components/ProtectedRoute';
import BackRedirectHandler from './backRedirectHandler';
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
// Add a request interceptor
const token = localStorage.getItem('token') && localStorage.getItem('token') != 'undefined' ? JSON.parse(localStorage.getItem('token')) : '';
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [user,setUser] = useState({
    user_id:userData?.login_user_name,
    password:userData?.login_password,
    company_id:userData?.agency_id
});
const [hasNavigated, setHasNavigated] = useState(false);


useEffect(() => {
  if (!token) {
    if (location.pathname !== '/') {
      navigate('/', { replace: false }); // Use replace: false to add to browser history
    }
    dispatch(setLoading(false));
    return;
  }

  if (token && location.pathname === '/') {
    navigate('/home/dashboard', { replace: false }); // Use replace: false to add to browser history
  }
}, [token, location.pathname, dispatch, navigate]);
//console.log("place3", localStorage.getItem('token'));
useEffect(() => {
  let lastActivityTime = Date.now();
  const IDLE_LIMIT = parseInt(localStorage.getItem('expireTime'), 10);

  const handleUserActivity = () => {
    lastActivityTime = Date.now();
  };

  const checkIdleTime = () => {
    const currentTime = Date.now();
    const idleTime = currentTime - lastActivityTime;

    if (idleTime >= IDLE_LIMIT) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      localStorage.removeItem('refreshtoken');
      localStorage.removeItem('expireTime');
      dispatch(setLoading(false));
      navigate('/', { replace: true }); // Use replace: true for logout
    }
  };

  const events = ['mousemove', 'keydown', 'scroll', 'click'];
  events.forEach((event) => {
    window.addEventListener(event, handleUserActivity);
  });

  const intervalId = setInterval(checkIdleTime, 10000);

  return () => {
    clearInterval(intervalId);
    events.forEach((event) => {
      window.removeEventListener(event, handleUserActivity);
    });
  };
}, [dispatch, navigate]);


axios.interceptors.request.use(function (config) {
  if(config.url.indexOf('/login') === -1 ){
    const token = JSON.parse(localStorage.getItem('token'));
   
   config.headers.authorization =  token;
   return config;

  }else{
    return config;
  }
   
 });



  
 
 axios.interceptors.response.use( (response) => {
  if (response?.status === 401) {
    return Promise.reject(response);
  }
  return response;
},async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
  try{
    // Token has expired, use the refresh token to obtain a new access token
    const refreshToken = JSON.parse(localStorage.getItem('refreshtoken'));
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/refresh-token`, {
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
    });
    const newAccessToken = JSON.stringify(response.data.access_token);
    //console.log("place2", newAccessToken);
    localStorage.setItem('token', JSON.stringify(response.data.access_token));
    localStorage.setItem('refreshtoken', JSON.stringify(response.data.refreshtoken));
    // Retry the original request with the new access token
    axios.defaults.headers.common['authorization'] = JSON.parse(newAccessToken);
    originalRequest.headers['authorization'] = JSON.parse(newAccessToken);
    return axios(originalRequest);
  
}catch (error) {
  console.error('Error refreshing token:', error);
  return Promise.reject(error);
}
}
    return Promise.reject(error);
});


  return (
    <>
      <BackRedirectHandler />
     <div style={{
       position: "relative",
       width: "100%",
       height: "100%",
       minHeight: "100%",
       overflow: "auto",
       WebkitOverflowScrolling: "touch",
     }}>
       <Routes >
         <Route exact path="/" element={<Login />} />
         <Route exact path="/home" element={<Navigate to="/home/dashboard" replace />} />
         <Route path="/home/*" element={
           <ProtectedRoute>
               <Home />
           </ProtectedRoute>
           
           } />
         <Route path="*" element={<Page404 />} />
       </Routes>
       {/* <Loader isLoading={loading}/>   */}
     </div>
    
     </>
     
   );
}

export default App;
